import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const CustomerOrderDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'customer-order',
        routeParamKey: 'customerOrderId',
        pageTitle: 'CustomerOrder Details',
        backRoute: '/customer-orders',
        backLabel: 'Back to CustomerOrders',
        tabIdPrefix: 'customer-order',
        tabsAriaLabel: 'customer-order detail tabs',
        missingIdMessage: 'No customer-order ID provided in the URL.',
        noDataMessage: 'No customer-order data available. The customer-order might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default CustomerOrderDetailPage;
